import angular from 'angular'
export default angular.module('angular-growl', []).name;